import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { heroShows } from '@/mocks/shows';

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % heroShows.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const handleSearch = useCallback((e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/category/all?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  }, [searchQuery, navigate]);

  const currentShow = heroShows[currentSlide];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-label="热门推荐">
      {heroShows.map((show, index) => (
        <div
          key={show.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={show.coverImage}
            alt={show.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
            热门综艺节目
            <span className="block text-primary-400">免费在线观看</span>
          </h1>
          <p className="mt-4 md:mt-6 text-sm md:text-base text-background-200/90 max-w-xl mx-auto leading-relaxed">
            6789影院收录全网热门综艺节目，高清流畅不缓冲，即点即播随时畅享。爆笑综艺、音乐选秀、真人秀全收录，每日更新精彩不断。
          </p>

          <form onSubmit={handleSearch} className="mt-8 md:mt-10 max-w-lg mx-auto relative">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="搜索你喜欢的综艺节目..."
              className="w-full h-12 md:h-14 pl-5 pr-36 rounded-full bg-background-50/95 backdrop-blur-sm border-2 border-transparent focus:border-primary-400 text-sm md:text-base text-foreground-900 placeholder:text-foreground-400 focus:outline-none transition-all duration-300"
            />
            <button
              type="submit"
              className="absolute right-1.5 top-1/2 -translate-y-1/2 h-9 md:h-11 px-6 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              搜 索
            </button>
          </form>

          <div className="mt-6 md:mt-8 flex items-center justify-center gap-3 flex-wrap">
            <span className="text-xs text-background-300 whitespace-nowrap">热门搜索：</span>
            {['脱口秀大会', '中国好声音', '奔跑吧兄弟', '明星大侦探'].map(tag => (
              <button
                key={tag}
                onClick={() => {
                  setSearchQuery(tag);
                  navigate(`/category/all?q=${encodeURIComponent(tag)}`);
                }}
                className="px-3 py-1 rounded-full bg-background-50/20 text-background-100 text-xs hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer whitespace-nowrap backdrop-blur-sm"
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        <div className="absolute bottom-8 md:bottom-10 flex items-center gap-2">
          {heroShows.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-2 h-2 md:w-2.5 md:h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
                index === currentSlide
                  ? 'bg-primary-500 w-6 md:w-8'
                  : 'bg-background-50/40 hover:bg-background-50/70'
              }`}
              aria-label={`第${index + 1}张`}
            />
          ))}
        </div>
      </div>

      <div className="absolute bottom-20 md:bottom-24 left-4 md:left-6 right-4 md:right-6 z-10 hidden md:block">
        <div className="max-w-6xl mx-auto">
          <p className="text-background-200 text-sm mb-2 font-medium">当前热播</p>
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg overflow-hidden flex-shrink-0 border-2 border-primary-500">
              <img src={currentShow.coverImage} alt={currentShow.title} className="w-full h-full object-cover" />
            </div>
            <div>
              <h2 className="text-background-50 text-sm md:text-base font-heading font-semibold">{currentShow.title}</h2>
              <p className="text-background-300 text-xs">{currentShow.rating} 分 · {currentShow.views} 播放</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}